import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";

export const renderMiniTeamsScore = (score1: string, score2: string) =>
<div className="rj-ev-list__mini-ev-card__scores-inner">
    <EventCardSectionItem content={score1} className="rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-home" />
    -
    <EventCardSectionItem content={score2} className="rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-away" />
</div>